module.exports = __webpack_public_path__ + "img/category-favorite.7ca16b2c.png";